import { format } from "date-fns";

export const formatDate = (date: string) => {
  const d = parseDate(date);
  if (d) {
    return format(d, "EEEE dd MMMM yyyy");
  }
  return "";
};

export const formatDateTime = (date: string) => {
  const d = parseDate(date);
  if (d) {
    return format(d, "EEEE dd MMMM yyyy HH:mm");
  }
  return "";
};

export const formatTime = (date: string) => {
  return format(new Date(date), "HH:mm");
};

// parse date from 'yyyyMMdd' to date object
export const parseDate = (date: string) => {
  if (date && date.length === 8) {
    return new Date(
      parseInt(date.substring(0, 4)),
      parseInt(date.substring(4, 6)) - 1,
      parseInt(date.substring(6, 8))
    );
  }
  return null;
};

// prase datetime from 'yyyyMMddHHmm' to date object
export const parseDateTime = (date: string) => {
  if (date && date.length === 12) {
    return new Date(
      parseInt(date.substring(0, 4)),
      parseInt(date.substring(4, 6)) - 1,
      parseInt(date.substring(6, 8)),
      parseInt(date.substring(8, 10)),
      parseInt(date.substring(10, 12))
    );
  }
  return null;
};

// convert date object to 'yyyyMMdd' string using date-fns
export const formatDateToYYYYMMDD = (date: Date) => {
  return format(date, "yyyyMMdd");
};

// convert date object to 'yyyyMMddHHmm' string using date-fns
export const formatDateToYYYYMMDDHHMM = (date: Date) => {
  return format(date, "yyyyMMddHHmm");
};

export const formatToTimeStamp = (date: Date) => {
  return format(date, 'yyyyMMddHHmmssSSS');
}

export const getStartAndEndDates = (dates: string[]) => {
  if (!dates || (dates && dates.length === 0)) {
    return { startDate: "", endDate: "" };
  }
  // order dates
  dates.sort();
  return {
    startDate: formatDate(dates[0]),
    endDate: formatDate(dates[dates.length - 1]),
  };
};

export const formatDateToDDMMMYYYY = (date: string) => {
  const d = parseDate(date);
  if (d) {
    return format(d, "dd MMM yyyy");
  }
  return "";
};

export const showDateShort = (date: string) => {
  if (date && date.indexOf("-") !== -1) {
    return `${formatDateToDDMMMYYYY(date.split("-")[0])} to ${formatDateToDDMMMYYYY(
      date.split("-")[1]
    )}`;
  } else if (date && date.indexOf("-") === -1) {
    return formatDateToDDMMMYYYY(date);
  }
  return "";
};


export const showDate =  (date: string) => {
    if (date && date.indexOf("-") !== -1) {
      return `${formatDate(date.split("-")[0])} to ${formatDate(
        date.split("-")[1]
      )}`;
    } else if (date && date.indexOf("-") === -1) {
      return formatDate(date);
    }
    return "";
  };

export const showDateTime = (date: string) => {
  if (date && date.indexOf("-") !== -1) {
    return `${formatDateTime(date.split("-")[0])} to ${formatDateTime(
      date.split("-")[1]
    )}`;
  } else if (date && date.indexOf("-") === -1) {
    const dt = parseDateTime(date);
    if (dt) {
      return format(dt, "EEEE dd MMMM yyyy HH:mm");
    }
  }
  return "";
}


export const showDateTimeShort = (date: string) => {
  if (date && date.indexOf("-") !== -1) {
    return `${formatDateTime(date.split("-")[0])} to ${formatDateTime(
      date.split("-")[1]
    )}`;
  } else if (date && date.indexOf("-") === -1) {
    const dt = parseDateTime(date);
    if (dt) {
      return format(dt, "dd MMM yyyy HH:mm");
    }
  }
  return "";
}

export const showTimeWithColon = (time: string) => {
  if (time && time.length === 4) {
    return `${time.substring(0, 2)}:${time.substring(2, 4)}`;
  }
  return "";
}